import type {
  ClientResponse,
  ClientData,
  MessagesResponse,
  MessagesData,
  Message,
  IssuesResponse,
  IssuesData,
} from '../types';

export const formatClient = (response: ClientResponse): ClientData => {
  return {
    customerDetails: {
      firstName: response.firstName,
      lastName: response.lastName,
      fullName: response.fullName,
      phone: response.phone,
      email: response.email,
    },
    accountDetails: {
      inboxState: response.inboxState.split('_').join(' '),
      clientCareState: response.clientCareState,
      lastContactDate: response.more.lastContact,
      notes: response.notes,
    },
    businessDetails: {
      company: response.company,
      structure: response.more.structure,
      filingType: response.more.filingType,
      naics: response.more.naics,
      industry: response.more.industry,
    },
    benchContacts: {
      bookkeeper: {
        primary: {
          fullName:
            response.assignedPersons.bookkeepers.primary?.fullName ||
            response.assignedPersons.accountants.primary?.fullName ||
            '',
          id:
            response.assignedPersons.bookkeepers.primary?.id ||
            response.assignedPersons.accountants.primary?.id ||
            '',
        },
      },
    },
  };
};

export const formatMessages = (response: MessagesResponse, clientName: string): MessagesData => {
  const recentMessages: Message[] = response.events.full.map(event => {
    const type = event.context.eventSource.authorRoles.includes('CLIENT') ? 'INCOMING' : 'OUTGOING';
    const senderName = type === 'INCOMING' ? clientName : 'Bench';
    return {
      senderName,
      type,
      messageBody: event.assets[0].payload,
      date: new Date(parseInt(event.createdAt)),
    };
  });
  return {
    recentMessages,
  };
};

export const formatIssues = (response: IssuesResponse): IssuesData => {
  return { ...response.getMessageSummary };
};
